<template lang="pug">
  include ./../../mixins
  +b.control
    +e.elements
      +b.INPUT.control-input(
        :ref="refName ? refName : 'input'",
        @focus="$emit('focus');inputMaskTrigger(true)"
        @blur="$emit('blur');inputMaskTrigger(false)"
        @keypress.enter="$emit('enter')"
        @input="$emit('input',$event.target.value)"
        v-bind="[$props, $attrs]"
        :value="value",
        :class="{'is-error': errors[0]}")
      +e.label(
        :class= "{'is-active': (value || maskIsActive) ? true : false}"
        v-if="label"
      )
        label {{ label }}
      slot(name='icon')
    +e.meta(v-if="errors[0]")
      +e.help
        +b.SPAN.help.--type_error(:class='{"is-error": errors[0]}') {{ errors[0] }}
</template>

<script>
export default {
  props: {
    name: String,
    type: String,
    label: String,
    refName: String,
    disabled: Boolean,
    errors: {},
    value: {},
    mask: String,
  },
  data() {
    return {
      maskIsActive: false,
    }
  },
  mounted() {
    let refName = this.refName ? this.refName : 'input'
    this.$refs[refName].type = this.type
    this.setInputMask(refName)
  },
  methods: {
    setInputMask(refName) {
      if (this.mask) {
        let im = new Inputmask(this.mask, {'placeholder': '.'})
        im.mask(this.$refs[refName])
      }
    },
    inputMaskTrigger(trigger) {
      this.maskIsActive = trigger
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Input/Input.vue